import CloseIcon from '@mui/icons-material/Close'
import { DialogTitle } from '@mui/material'
import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import { TypographyProps } from '@mui/material/Typography'
import { ReactNode } from 'react'

export interface HeaderProps {
  onClose?: IconButtonProps['onClick']
  align?: TypographyProps['align']
  children: ReactNode
}
const Header = ({ children, onClose, align }: HeaderProps) => {
  return (
    <DialogTitle textAlign={align} sx={{ m: 0, p: 2 }}>
      {children}
      {onClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ p: 0.5, color: 'grey.500', float: 'right' }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  )
}

export default Header
